import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/fbPixel';
interface CtaSectionProps {
  className?: string;
  showTrustBadges?: boolean;
}
export function CtaSection({
  className = '',
  showTrustBadges = true
}: CtaSectionProps) {
  return <div className={`flex flex-col items-center justify-center w-full ${className}`} data-id="element-31">
      <motion.a href="https://www.calmin3x3.com/cart/54026042310940:1" target="_blank" rel="noopener noreferrer" onClick={() => {
      trackAddToCart();
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} animate={{
      boxShadow: ['0px 0px 0px 0px rgba(197, 160, 89, 0)', '0px 0px 30px 10px rgba(197, 160, 89, 0.45)', '0px 0px 0px 0px rgba(197, 160, 89, 0)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="relative group w-full max-w-2xl" data-id="element-32">
        <div className="absolute -inset-1.5 rounded-2xl blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" style={{
        background: 'linear-gradient(90deg, #a8863a, #C5A059, #d4b96a, #C5A059, #a8863a)'
      }} data-id="element-33"></div>
        <button className="relative w-full text-black py-6 px-10 rounded-2xl shadow-2xl flex items-center justify-center gap-3 overflow-hidden uppercase tracking-wider" style={{
        background: 'linear-gradient(180deg, #d4b96a, #C5A059, #B38F44)',
        border: '2px solid #d4b96a',
        fontFamily: "'Space Grotesk', sans-serif",
        fontWeight: 700,
        fontSize: 'clamp(1.1rem, 2.5vw, 1.6rem)'
      }} data-id="element-34">
          <Lock className="relative z-10 w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" data-id="element-35" />
          <span className="relative z-10" data-id="element-36">YES! I WANT MY 750+ SCORE NOW →</span>

          {/* Shine effect */}
          <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-30 group-hover:animate-shine" data-id="element-37" />
        </button>
      </motion.a>

      {/* Micro-copy */}
      <div className="flex items-center gap-2 mt-3 text-gray-400 text-sm" data-id="element-38">
        <Lock className="w-3.5 h-3.5 text-gray-500" data-id="element-39" />
        <p data-id="element-40">
          Secure Checkout · One-time payment · Lifetime access · 100% Risk-Free
          Guarantee
        </p>
      </div>

      {showTrustBadges && <div className="flex flex-wrap justify-center gap-4 sm:gap-8 mt-4 text-gray-500 text-sm" data-id="element-41">
          <div className="flex items-center gap-2" data-id="element-42">
            <Lock className="w-4 h-4 text-gray-600" data-id="element-43" />
            <span data-id="element-44">256-Bit SSL Secure</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-45">
            <ShieldCheck className="w-4 h-4 text-gray-600" data-id="element-46" />
            <span data-id="element-47">30-Day Guarantee</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-48">
            <Zap className="w-4 h-4 text-gray-600" data-id="element-49" />
            <span data-id="element-50">Instant Digital Access</span>
          </div>
        </div>}
    </div>;
}